import { CommonModule, LOCATION_INITIALIZED } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

/**
 * Return translate json file path
 */
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * Catch every missing translations
 */
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return '#' + params.key + '#';
  }
}

/**
 * Await translation loading before fully initialize application using APP_INITIALIZER
 */
export function appInitializerFactory(
  translate: TranslateService,
  injector: Injector
) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );

      locationInitialized.then(() => {
        const langToSet = sessionStorage.getItem('activeLanguage');
        // Use session active language if set
        if (langToSet) {
          translate.setDefaultLang(langToSet);
          translate
            .use(langToSet)
            .subscribe(() => { }, () => { }, () => resolve(null));
        } else {
          // Else, use browser language
          var language = translate.getBrowserCultureLang();
          if (!language)
            language = "fr-FR";
          if (language.includes("fr"))
            language = "fr-FR";
          else if (language.includes("en"))
            language = "en-EN";
          else if (language.includes("es"))
            language = "es-ES";

          translate.setDefaultLang(language);
          translate.use(language).subscribe(
            () => { },
            () => {
              // If browser language is unavailable, default to 'fr-FR'
              translate.setDefaultLang('fr-FR');
              translate
                .use('fr-FR')
                .subscribe(() => { }, () => { }, () => resolve(null));
            },
            () => resolve(null)
          );
        }
      });
    });
}

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      extendedTimeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      maxOpened: 5,
      closeButton: true,
      tapToDismiss: true,
      easeTime: 170,
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    NgxDatatableModule,
  ],
  declarations: [],
  exports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    }
  ],
})
export class VendorModule { }
